import React from "react"
import CustomButton from "../shared/CustomButton"
import KeyDropdownValue from "../shared/KeyDropdownValue"
import InputKeyValue from "../shared/InputKeyValue"
import { CloseMD } from "../normalizer"

const BonusPointsAddForm = ({
  colleagues,
  selectedColleague,
  onChangeColleague,
  onUpdatePoints,
  points,
  onSubmitForm,
  formErrors,
  clientProducts,
  selectedProduct,
  onChangeProduct,
  campaign,
  onClose,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmitForm()
  }

  return (
    <div className="bonus-points-add-modal">
      <div className="bonus-points-add-modal__header">
        <h4 className="bonus-points-add-modal__title">Atribuir pontos</h4>
        {onClose && (
          <button
            type="button"
            className="bonus-points-add-modal__close"
            onClick={onClose}
            aria-label="Fechar"
          >
            <CloseMD />
          </button>
        )}
      </div>
      <p className="bonus-points-add-modal__description">
        Selecione o nome do utilizador, o produto e indique o número de pontos a atribuir.
      </p>
      <form onSubmit={handleSubmit} className="bonus-points-add-modal__form">
        <KeyDropdownValue
          title="Nome do utilizador"
          isClearable
          campaign={campaign}
          onChange={onChangeColleague}
          options={colleagues}
          getOptionLabel={option => option.employee_identifier || option.email}
          selectedValue={selectedColleague}
          getOptionValue={option => option.id}
          placeholder="Seleccione o utilizador"
          name="bonus-points-user-select"
        />
        {formErrors['colleague'] && (
          <span className="bonus-points-add-modal__error">{formErrors['colleague']}</span>
        )}

        <KeyDropdownValue
          title="Produto a atribuir"
          isClearable
          campaign={campaign}
          onChange={onChangeProduct}
          options={clientProducts}
          getOptionLabel={option => option.external_identifier || option.name}
          selectedValue={selectedProduct}
          getOptionValue={option => option.id}
          placeholder="Seleccione o produto"
          name="bonus-points-product-select"
        />
        {formErrors['product'] && (
          <span className="bonus-points-add-modal__error">{formErrors['product']}</span>
        )}

        <InputKeyValue
          title="Número de pontos a atribuir"
          type="number"
          onChange={(e) => onUpdatePoints(e)}
          value={points}
          placeholder="Indique o número de pontos"
          name="bonus-points-amount"
          min="1"
        />
        {formErrors['number'] && (
          <span className="bonus-points-add-modal__error">{formErrors['number']}</span>
        )}

        <div className="bonus-points-add-modal__actions">
          {onClose && (
            <CustomButton type="button" secondary onClick={onClose}>
              Cancelar
            </CustomButton>
          )}
          <CustomButton type="submit" terciary>
            Atribuir
          </CustomButton>
        </div>
      </form>
    </div>
  )
}

export default BonusPointsAddForm
